<div mat-dialog-content class="w-full">
	<div
		class="mx-auto max-w-3xl transform divide-y divide-gray-100 overflow-hidden rounded-xl bg-white shadow-2xl ring-1 ring-black ring-opacity-5 transition-all"
	>
		<div class="relative">
			<mat-icon
				class="pointer-events-none absolute left-4 top-3.5 h-5 w-5 text-gray-400"
				svgIcon="heroicons_outline:magnifying-glass"
			></mat-icon>
			<input
				type="search"
				class="h-12 w-full border-0 bg-transparent pl-11 pr-4 text-gray-800 placeholder:text-gray-400 focus:ring-0 sm:text-sm"
				placeholder="Search..."
				[formControl]="searchControl"
			/>
		</div>
		<div
			class="divide-x divide-gray-100"
			[class.flex]="searchResultLength > 0"
			[class.hidden]="searchResultLength == 0"
		>
			<div
				class="max-h-96 min-w-0 flex-auto scroll-py-4 overflow-y-auto px-6 py-4 sm:h-96"
			>
				@for (groupItem of searchResult$ | async; track groupItem) {
				<h2 class="mb-4 mt-2 text-xs font-semibold text-gray-500">
					{{ groupItem.referenceType | camelCaseString }}
				</h2>
				<ul
					class="-mx-2 text-sm text-gray-700"
					id="recent"
					role="listbox"
				>
					@if (!isSmallScreen) { @for (item of groupItem.items; track
					item) {
					<li
						class="group flex cursor-pointer sm:cursor-default select-none items-center rounded-md p-2 h-10 hover:bg-gray-100 text-gray-900"
						[class.bg-gray-100.text-gray-900]="
							item.referenceId == searchItem?.referenceId &&
							item.referenceType == searchItem?.referenceType
						"
						(mouseenter)="onMouseEnter(item)"
					>
						<span class="ml-3 flex-auto truncate">{{
							item.title
						}}</span>
						<mat-icon
							class="ml-3 h-5 w-5 flex-none text-gray-400 group-hover:block"
							[class.block]="
								item.referenceId == searchItem?.referenceId &&
								item.referenceType == searchItem?.referenceType
							"
							[class.hidden]="
								item.referenceId != searchItem?.referenceId ||
								item.referenceType != searchItem?.referenceType
							"
							svgIcon="mat_outline:keyboard_arrow_right"
						></mat-icon>
					</li>
					} } @else { @for (item of groupItem.items; track item) {
					<li
						class="group flex cursor-pointer sm:cursor-default select-none items-center rounded-md p-2 h-10 hover:bg-gray-100 text-gray-900"
						[class.bg-gray-100.text-gray-900]="
							item.referenceId == searchItem?.referenceId &&
							item.referenceType == searchItem?.referenceType
						"
						(click)="goToPage(item)"
					>
						<span class="ml-3 flex-auto truncate">{{
							item.title
						}}</span>
					</li>
					} }
				</ul>
				}
			</div>
			@if (searchItem) {
			<div
				class="hidden h-96 w-2/3 flex-none flex-col divide-y divide-gray-100 sm:flex p-4"
			>
				@if (searchItem?.quickActionContent) {
				<div class="flex-1 overflow-x-hidden overflow-y-auto">
					@switch (searchItem.referenceType) { @case ('Claims') {
					<cm-quick-view-claim
						[quickAction]="searchItem.quickActionContent"
						(onClose)="closeSearch()"
					></cm-quick-view-claim>
					} @case ('Companies') {
					<cm-quick-view-company
						[quickAction]="searchItem.quickActionContent"
					>
					</cm-quick-view-company>
					} @case ('Contacts') {
					<cm-quick-view-contact
						[quickAction]="searchItem.quickActionContent"
						(onClose)="closeSearch()"
					></cm-quick-view-contact>
					} @case ('Leads') {
					<cm-quick-view-lead
						[quickAction]="searchItem.quickActionContent"
					></cm-quick-view-lead>
					} @case ('Users') {
					<cm-quick-view-user
						[quickAction]="searchItem.quickActionContent"
						(onClose)="closeSearch()"
					></cm-quick-view-user>
					} }
				</div>
				<button
					type="button"
					class="mt-4 w-full rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
					(click)="goToPage()"
				>
					@switch (searchItem.referenceType) { @case ('Claims') { Go
					to claim } @case ('Companies') { Go to company } @case
					('Contacts') { Go to contact } @case ('Leads') { Go to lead
					} }
				</button>
				} @else {
				<div class="px-6 hide py-14 text-center text-sm sm:px-14">
					<mat-icon
						svgIcon="heroicons_outline:viewfinder-circle"
					></mat-icon>
					<p class="mt-4 font-semibold text-gray-900">
						No quick action found
					</p>
				</div>
				}
			</div>
			}
		</div>
		@if (searchResultLength == 0) {
		<div class="px-6 hide py-14 text-center text-sm sm:px-14">
			<mat-icon svgIcon="heroicons_outline:user-group"></mat-icon>
			<p class="mt-4 font-semibold text-gray-900">No item found</p>
			<p class="mt-2 text-gray-500">
				We couldn’t find anything with that term. Please try again.
			</p>
		</div>
		}
	</div>
</div>
